export default __webpack_public_path__ + "static/media/Logo_white.0739d02b.svg";